import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
  ButtonGroup,
  DropdownButton,
  MenuItem
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
//import Alert          from '../../../components/alert/Alert';
import { createBrowserHistory } from 'history';
import {
  NewBreadcrumb as BreadcrumbComponent
}                        from '../../../components';

// include action file for add merchant
import '../../../style/subAdmin/SubAdmin.scss';
import { Notification } from '../../../components/notifications';
import isEmpty from 'lodash.isempty';
import { templateList} from '../../../redux/actions/pageTemplateAction';
import {renderAlert, clearAlert} from '../../../redux/actions/alertsActions';
import moment from 'moment';
import loader from '../../../style/loader/loader.scss'; 
import '../../../style/react-datetimepicker.scss';

import ReactHtmlParser from 'react-html-parser';
import Dialog from 'react-bootstrap-dialog';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

import Pagination from 'react-paginating';
const history = createBrowserHistory();

const HorizontalLine = ({ }) => (
    <hr/>
);

const propTypes = {
    emailOverview: PropTypes.func.isRequired,
};
let cityItems=[];let isLoading="false",  csvData = [];

class PageTemplate extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props){

    super(props);
    this.state={
      path: ['Home', 'Page Template'], 
      links: ["home",'page-template'],
      list: [],
    }

  }

  
  componentWillMount(){
  	isLoading="true";
  	this.props.templateList();
  }

  componentWillReceiveProps(nextProps){
  	if(this.props.list !== nextProps.list){
  		if(nextProps.list){
  			isLoading="false";
  			this.setState({list: nextProps.list.data.data})
  		}
  	}
  }

  render() {   
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus')); 
    return (
      <div className="col-lg-12 add-sub-admin">
        <Dialog ref={(el) => { this.dialog = el }} />
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
       
        <div className="row">
          <div className="col-xs-12">
             <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
          </div>
        </div>
        <div className="panel">
          	<header className="panel-heading">Page Template</header>
	        <div className="panel">
	          {this.state.show && this.state.alertMessage !=='' &&        
	            <div className="col-lg-12">
	              	<Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
		              <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
		            </Alert>
	            </div>
	          }
	          	<div className="panel-body">
		          <table className="table table-hover table-bordered">
		            <thead>
		              <tr>
		                <th>#</th>
		                <th>Page Name</th>
		                <th>Template Type</th>
		                <th>Action</th>
		              </tr>
		            </thead>
		            <tbody>
		               {(this.state.list) &&
        							this.state.list.map((list, index) => 
                          (siteData && siteData.dynamic_footer === 1 && list.templateType === 'FooterContent') ?
      						        <tr key={index}>
      						        	<td>{++index}</td>
      						        	<td>{list.title}</td>
      						        	<td>{list.templateType}</td>
      						        	<td><Button bsStyle="success" onClick={() => this.context.router.history.push(`/footer-template`)}>Edit Page HTML</Button></td>
      						        </tr>
                          : (siteData && siteData.dynamic_header === 1 && list.templateType === 'HeaderContent') ?
                          <tr key={index}>
                            <td>{++index}</td>
                            <td>{list.title}</td>
                            <td>{list.templateType}</td>
                            <td><Button bsStyle="success" onClick={() => this.context.router.history.push(`/header-template`)}>Edit Page HTML</Button></td>
                          </tr>
                          : (list.templateType !== 'FooterContent' && list.templateType !== 'HeaderContent') ?
                          <tr key={index}>
                            <td>{++index}</td>
                            <td>{list.title}</td>
                            <td>{list.templateType}</td>
                            <td><Button bsStyle="success" onClick={() => this.context.router.history.push(`/edit-page-template/${list.templateType}`)}>Edit Page HTML</Button></td>
                          </tr>
                          : ""
        							)
        					}
		            </tbody>
		          </table>
	        	</div>
	        </div>
	    </div>
	  </div>
    );
  }
}
 
 

const mapStateToProps = (state,ownProps) => {
    return {
    	list: state.pageTemplateReducer.templateList,
    };
};

export default compose(
  withRouter, 
  connect(mapStateToProps, {templateList})
)(PageTemplate);



// WEBPACK FOOTER //
// ./src/app/views/admin/pageTemplate/PageTemplate.js